import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Accordion, Card, ListGroup } from "react-bootstrap";
import {
  COMPANY,
  NOTES,
  VOB_MERCHANDISE_TYPE_MARKETPLACE,
  STATUS_PLATFORMTYPE_MIRAKL,
  DISPLAY_FOR_MP,
  DISPLAY_FOR_NON_MP,
  DISPLAY_FOR_ALL_DVN_AUDIT,
  VOB_MERCHANDISE_TYPE_OWNED_VENDOR,
  STATUS_PLATFORMTYPE_DIRECTEDI,
} from "../../../../constants/Constants";
import CircleProgress from "../RoundProgressBar/RoundProgressBar";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import "./LeftSideNav.css";
import "../../../../assets/css/Common.css";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { updateCommonInfo } from "../../../../redux/commonSlice";
import { updateLeftNav } from "../../../../redux/leftNavSlice";
import { renderLeftNavItem } from "../../../../utils/utils";
import {
  VENDORPLATFORM_VENDORONBOARDING_LEFTSIDENAV,
  VMP_ONBOARDING_STATUS,
  VIEW,
  ALL,
  NONE,
} from "../../../../constants/RolePermissionConstants";
import {
  companyInfoAccordion,
  preBoardingAccordion,
  integrationAccordion,
  publishAccordion,
} from "./LinkItemValues";
import { updateServiceData } from "../../../../redux/serviceSlice";

const LeftSideNav = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { step, type = COMPANY } = props.params;
  const pageID = step || type;
  const store = useSelector(
    (state) => ({
      boardingStatuses: state.common.boardingStatuses,
      percentCompletion: state.service.vendorStatus[0]?.percentCompletion,
      profileId: state.common.profileId,
      duns: state.common.duns,
      vendorCorpName: state.common.vendorCorpName,
      vendorConnectionPlatform: state.common.vendorConnectionPlatform,
      primaryContact: state.leftNav.primaryContact,
      activeAccordionKey: state.leftNav.activeAccordionKey,
      selectedSection: state.leftNav.selectedSection,
      profileTypeDetails: state.service.vendorProfile?.profileTypeDetails,
      workflowSteps: state.service.workflowSteps,
      merchandiseType:
        state.service.vendorProfile?.vendorDetail?.merchandiseType || "",
      hierarchyDetails:
        state.service.vendorProfile?.vendorDetail?.hierarchyDetails || [],
      vendorMenuItems: state.common.vendorMenuItems || [],
    }),
    shallowEqual
  );

  const [newVendorProfile, setNewVendorProfile] = useState("");
  useEffect(() => {
    if (newVendorProfile) {
      localStorage.setItem("vid", newVendorProfile);
      dispatch(
        updateServiceData({
          vendorProfile: {},
          vendorStatus: [],
          notes: [],
          fetching: true,
        })
      );
      dispatch(updateCommonInfo({ profileId: newVendorProfile }));
      history.push(`/boarding/vendor/company/${newVendorProfile}`);
    }
  }, [newVendorProfile]);

  useEffect(() => {
    if (pageID !== NOTES) {
      onToggleHandler({ activeAccordionKey: "", selectedSection: "" });
    }
  }, [pageID]);

  const onChangeVendorFulfillConnection = (e) =>
    dispatch(updateCommonInfo({ profileId: e.target.value }));

  const onToggleHandler = ({ activeAccordionKey, selectedSection }) => {
    dispatch(
      updateLeftNav({
        selectedSection,
        activeAccordionKey,
      })
    );
  };

  const renderListItem = (info) => {
    const { linkInfo, eventKey, accordionName, displayFor } = info;

    /**
     * If it is Non MP specific menu item,
     * check for merchandiseType and vendorConnectionPlatform
     * Hide only if vendor is MP and Mirakl, otherwise display the menu.
     */
    if (
      displayFor === DISPLAY_FOR_NON_MP &&
      store.merchandiseType === VOB_MERCHANDISE_TYPE_MARKETPLACE &&
      STATUS_PLATFORMTYPE_MIRAKL.includes(store.vendorConnectionPlatform)
    ) {
      return null;
    }
    return (
      <Card style={{ width: "100%", paddingLeft: 10 }}>
        <Accordion.Toggle
          as={Card.Header}
          variant="link"
          eventKey={eventKey}
          className={`d-flex w-100 justify-content-between align-items-center 
              ${
                store.activeAccordionKey === eventKey
                  ? "accordianColorActive"
                  : "accordianColor"
              }`}
          onClick={(e) =>
            onToggleHandler({
              activeAccordionKey:
                store.activeAccordionKey === eventKey ? "" : eventKey,
              selectedSection: store.selectedSection,
            })
          }
          id={accordionName}
        >
          {accordionName}
          <span
            className={
              store.activeAccordionKey === eventKey
                ? "down-arrow-img"
                : "right-arrow-img"
            }
          ></span>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={eventKey}>
          <ListGroup variant="flush">
            {linkInfo.map(
              (
                {
                  id,
                  path,
                  statusColor,
                  linkName,
                  checkVDF,
                  pageRoleId,
                  displayFor,
                },
                idx
              ) => {
                /**
                 * If the menu item is set to be dependent dvn audit,
                 * then it should not appear if,
                 * 1. The DVN Audit tab will only exist for vendor records that
                 * contain at least one newly created DVN #.
                 * 2. The DVN Audit tab will not exist for vendor records that contain
                 * only DVN #'s that were created outside of this vendor record.
                 */
                if (
                  displayFor === DISPLAY_FOR_ALL_DVN_AUDIT &&
                  (!store.hierarchyDetails ||
                    (store.hierarchyDetails &&
                      store.hierarchyDetails.length === 0) ||
                    !store.hierarchyDetails.find(
                      (item) =>
                        item.needDvnAudit &&
                        item.vendorNumber &&
                        item.vendorNumber?.toString() !== "0"
                    ))
                ) {
                  return null;
                }

                /**
                 * If it is MP specific menu item,
                 * check for merchandiseType and vendorConnectionPlatform
                 * Display only if vendor is MP and Mirakl, otherwise donot display .
                 */
                if (
                  displayFor === DISPLAY_FOR_MP &&
                  (store.merchandiseType !== VOB_MERCHANDISE_TYPE_MARKETPLACE ||
                    !STATUS_PLATFORMTYPE_MIRAKL.includes(
                      store.vendorConnectionPlatform
                    ))
                ) {
                  return null;
                }

                /**
                 * If it is Non MP specific menu item,
                 * check for merchandiseType and vendorConnectionPlatform
                 * Hide only if vendor is MP and Mirakl, otherwise display the menu.
                 */
                if (
                  displayFor === DISPLAY_FOR_NON_MP &&
                  store.merchandiseType === VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                  STATUS_PLATFORMTYPE_MIRAKL.includes(
                    store.vendorConnectionPlatform
                  )
                ) {
                  return null;
                }

                /**
                 * Display the menus based on vendorStatus records
                 * received from API for owned vendors.
                 */

                if (
                  id &&
                  store.vendorMenuItems &&
                  store.vendorMenuItems.length > 1 &&
                  !store.vendorMenuItems.includes(id)
                ) {
                  return null;
                }

                const routeSubstr = path(store.profileId).split("/");
                const { pathname } = history.location;
                const isMerchantApproval =
                  routeSubstr[2] === "merchant" &&
                  pathname.includes("merchant");
                const selected = store.selectedSection === linkName;
                if (
                  !store.selectedSection &&
                  (routeSubstr[3] === pageID || isMerchantApproval)
                ) {
                  onToggleHandler({
                    activeAccordionKey: eventKey,
                    selectedSection: linkName,
                  });
                }
                let listItem = (
                  <ListGroup.Item
                    className="d-flex w-100 justify-content-between align-items-center"
                    key={idx + "_leftNav_listGroup"}
                  >
                    <Link
                      className={
                        pageRoleId &&
                        getUserRolePermission(pageRoleId, ALL) === NONE
                          ? "disable-link"
                          : ""
                      }
                      style={selected ? { fontWeight: 600, fontSize: 15 } : {}}
                      to={path(store.profileId)}
                      onClick={() => {
                        dispatch(updateServiceData({ fetching: true }));
                        onToggleHandler({
                          activeAccordionKey: store.activeAccordionKey,
                          selectedSection: linkName,
                        });
                      }}
                      key={idx + "_leftNav_link"}
                    >
                      {linkName}
                    </Link>
                    <span
                      className={statusColor(store.boardingStatuses)}
                    ></span>
                  </ListGroup.Item>
                );

                if (!checkVDF) return listItem;
                return checkVDF &&
                  renderLeftNavItem(
                    store.vendorConnectionPlatform,
                    store.workflowSteps[checkVDF]
                  )
                  ? listItem
                  : null;
              }
            )}
          </ListGroup>
        </Accordion.Collapse>
      </Card>
    );
  };

  return (
    <div
      className="navMarginNoneMerApp flex-column nav-pills"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <Card style={{ width: "100%", paddingLeft: 10 }}>
        <Card.Title className="align-items-center card-title-ma">
          <div className="leftSideNavCardTitleContainer">
            <div className="leftSideNavCardTitle">
              <div className="fs-14 leftSideNavVendorCorpName">
                {store.vendorCorpName || null}
              </div>
              {store.profileTypeDetails && store.profileTypeDetails.length > 1 && (
                <div className="fs-14 leftSideNavFulfillmentTypeConnection">
                  <select
                    className="leftSideNavSelectFulfillmentTypeConnection"
                    onChange={(e) => setNewVendorProfile(e.target.value)}
                    value={store.profileId}
                  >
                    {store.profileTypeDetails.map((option) => (
                      <option
                        key={option.vendorProfileId}
                        value={option.vendorProfileId}
                      >
                        {option.profileType}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {getUserRolePermission(
                VENDORPLATFORM_VENDORONBOARDING_LEFTSIDENAV,
                VMP_ONBOARDING_STATUS
              ) === VIEW && (
                <div className="fs-14 leftSideNavOnboardingStatus">
                  {store.boardingStatuses?.onboardingStatus}
                </div>
              )}
            </div>
            <div className="leftSideNavCircleProgress">
              <CircleProgress percent={store.percentCompletion || 0} />
            </div>
          </div>
        </Card.Title>
        <div className="card-text-ma">
          <div>
            <div className="lh-1 fs-12 m-top-10">
              <p className="mt-4">
                <span className="bold">DUNS: </span>
                {store.duns}
              </p>
              <p>
                <span className="ma-top-div-phone"></span>
                {store.primaryContact.vendorPhone}
              </p>
              <p>
                <span className="ma-top-div-email"></span>
                {store.primaryContact.userEmail}
              </p>
              <span className="ma-top-div-loc"></span>

              <p className="contactText">
                {store.primaryContact.streetAddress
                  ? `${store.primaryContact.streetAddress},`
                  : ""}
                <br />
                <span>
                  {store.primaryContact.city
                    ? `${store.primaryContact.city},`
                    : ""}{" "}
                  {store.primaryContact.state
                    ? `${store.primaryContact.state},`
                    : ""}{" "}
                  {store.primaryContact.zipCode
                    ? `${store.primaryContact.zipCode},`
                    : ""}
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>

      <Accordion activeKey={store.activeAccordionKey} id="accordian-merch-app">
        {renderListItem(companyInfoAccordion)}
        {renderListItem(preBoardingAccordion)}
        {renderListItem(integrationAccordion)}
        {renderListItem(publishAccordion)}
      </Accordion>
    </div>
  );
};

export default LeftSideNav;
